<template>
	<div class="progress-container">
		<svg class="progress-circle" :width="size" :height="size">
			<circle
				class="progress-circle-background"
				:cx="halfSize"
				:cy="halfSize"
				:r="radius"
				:style="backgroundStyles"
				stroke-linecap="round"
			></circle>
			<circle
				class="progress-circle-progress"
				:cx="halfSize"
				:cy="halfSize"
				:r="radius"
				:style="progressStyles"
				stroke-linecap="round"
			></circle>
		</svg>
	</div>
</template>

<script setup lang="ts">
import { computed } from "vue";

const {
	progress = 0,
	size = 120,
	strokeWidth = 8,
	progressColor = "#4CAF50",
	backgroundColor = "#e6e6e6",
} = defineProps<{
	progress?: number;
	size?: number;
	strokeWidth?: number;
	progressColor?: string;
	backgroundColor?: string;
}>();

const radius = computed(() => size / 2 - strokeWidth / 2);
const circumference = computed(() => 2 * Math.PI * radius.value);
const halfSize = computed(() => size / 2);

const progressStyles = computed(() => {
	const offset = circumference.value - (progress / 100) * circumference.value;
	return {
		strokeDasharray: circumference.value,
		strokeDashoffset: offset,
		stroke: progressColor,
		strokeWidth: strokeWidth,
	};
});

const backgroundStyles = computed(() => {
	return {
		stroke: backgroundColor,
		strokeWidth: strokeWidth,
	};
});
</script>

<style scoped>
.progress-container {
	position: relative;
}

.progress-circle {
	transform: rotate(-90deg); /* Start the circle from the top */
	transform-origin: 50% 50%; /* Rotate around the center */
}

.progress-circle-background {
	fill: none;
}

.progress-circle-progress {
	fill: none;
}

.progress-text {
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	font-size: 1.5em;
	font-weight: bold;
	color: #333;
	user-select: none; /* Prevent text selection */
}
</style>
